import React from 'react';
import PropTypes from 'prop-types';

const AyristirmaIcon = ({ color = '#C70000', width = 7, height = 14 }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 482888">
    <g id="Group 482890">
    <rect id="Rectangle 2586" x="11.4211" y="1" width="7.57895" height="7.57895" rx="1" stroke={color} stroke-linejoin="round"/>
    <circle id="Ellipse 2181" cx="15.2105" cy="15.2105" r="3.78947" stroke={color}/>
    </g>
    <g id="Group 482889">
    <path id="Star 1" d="M4.44418 1.2952C4.61047 0.901601 5.15795 0.901601 5.32424 1.2952L6.06707 3.05347C6.13643 3.21764 6.28825 3.33007 6.46286 3.34658L8.33292 3.52337C8.75154 3.56295 8.92073 4.0937 8.60488 4.37653L7.19391 5.64C7.06216 5.75797 7.00418 5.93988 7.04273 6.11426L7.45566 7.9818C7.5481 8.39985 7.10517 8.72787 6.74368 8.50908L5.12882 7.53167C4.97803 7.44041 4.79039 7.44041 4.6396 7.53167L3.02474 8.50908C2.66325 8.72787 2.22033 8.39985 2.31276 7.9818L2.72569 6.11426C2.76424 5.93988 2.70626 5.75797 2.57451 5.64L1.16354 4.37653C0.847695 4.0937 1.01688 3.56295 1.4355 3.52337L3.30556 3.34658C3.48017 3.33007 3.63199 3.21764 3.70135 3.05347L4.44418 1.2952Z" stroke={color}/>
    <path id="Polygon 1" d="M4.39158 12.9705C4.77389 12.2909 5.75243 12.2909 6.13473 12.9705L8.68804 17.5097C9.06301 18.1763 8.58129 19 7.81647 19H2.70985C1.94502 19 1.46331 18.1763 1.83827 17.5097L4.39158 12.9705Z" stroke={color}/>
    </g>
    </g>
    </svg>
    
);

AyristirmaIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default AyristirmaIcon; 